import React from 'react';
import { useApp } from '../context/AppContext';
import { BackIcon } from './Icons';
import './Header.css';

interface HeaderProps {
  onBack: () => void;
  title: string;
  rightElement?: React.ReactNode;
  showBackButton?: boolean; // 可选的控制返回按钮显示
}

const Header: React.FC<HeaderProps> = ({ onBack, title, rightElement, showBackButton }) => {
  const { isElectronMode } = useApp();
  
  // 如果明确设置了showBackButton，使用该值；否则根据Electron模式决定
  const shouldShowBackButton = showBackButton !== undefined ? showBackButton : true;

  return (
    <div className="app-header">
      {shouldShowBackButton ? (
        <button className="header-back-button" onClick={onBack}>
          <BackIcon width="30" height="30" />
          返回
        </button>
      ) : (
        <div className="header-spacer"></div>
      )}
      <h2 className="header-title">{title}</h2>
      {rightElement ? rightElement : <div className="header-spacer"></div>}
    </div>
  );
};

export default Header;
